import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=881b8474&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=881b8474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b8474",
  null
  
)

export default component.exports